import createAction from '@framework/state/createAction';
import * as actionTypes from './actionTypes';

export default (state, dispatch) => {
  const setLeagueTableSearchState = (payload) => dispatch(createAction(
    actionTypes.SET_LEAGUE_TABLE_SEARCH_STATE,
    payload,
  ));

  const resetLeagueTableSearchState = () => dispatch(createAction(actionTypes.RESET_LEAGUE_TABLE_FILTERS_SEARCH));

  return {
    setLeagueTableSearchState,
    resetLeagueTableSearchState,
  };
};
